import React, {useEffect} from 'react';
import {Breadcrumbs} from '~/components/Breadcrumps';
import {Progress} from '~/components/Progress';
import {Table} from '~/components/Table';
import {Title} from '~/components/Title';
import {useResource} from '~/lib/loader';
import {fetchAppAdsDownloadHistory} from '~/modules/AppAds/api';
import {AppAdsNavigation} from '~/modules/AppAds/components/AppAdsNavigation';

export const DownloadHistoryView = () => {
    const result = useResource(() => fetchAppAdsDownloadHistory(), []);

    useEffect(() => {
        result.fetch();
    }, []);

    return <div>
        <div className="page-header-sticky">
            <div className="page-header-breadcrumbs">
                <Breadcrumbs/>
            </div>
            <Title className="page-header-title">Download history</Title>
        </div>
        <AppAdsNavigation/>
        <div className="layout-content-box">
        <Table header
            columns={[{
                header: 'Seller ID',
                field: 'sellerId'
            }, {
                header: 'Time',
                field: 'timestamp',
                cell: entry => new Date(entry.timestamp).toLocaleString()
            }]}
            records={result.resource}
            placeholder={result.isPending && <Progress/>}/>
        </div>
    </div>;
};
